import { setWindowWidth, setIsBlur } from "./ActionTypes";

export const setWindowAction = (width : number) => ({ 
    type : setWindowWidth ,
    payload : width
})

export const setBlurAction = (isBlur : boolean) => ({ 
    type : setIsBlur ,
    payload : isBlur
})